import { EnvironmentProviders, Provider } from '@angular/core';
import { ConstructionPartsObjectService } from './services/object.service';

// Cross-cutting/module-level providers WITHOUT the routes graph — composed at
// boot both by provideConstructionPartsModule (monolith path) and the remote's
// ./ModuleGlobals entry (federation path). Must not import the routes file.
export function provideConstructionPartsGlobals(): Array<
  Provider | EnvironmentProviders
> {
  return [ConstructionPartsObjectService];
}
